import { RouteConfigComponentProps } from 'react-router-config';
import { MemberMaintain } from 'constants/models/components/memberMaintain';
import { MemberProfile } from 'bff/models/member';
import { MemberMaintainStep } from 'constants/enums/memberMaintainStep.enum';
import { OTPInfo } from 'bff/models/login';

export interface IProps extends RouteConfigComponentProps { }

export interface IState extends MemberMaintain {
  /** 原始比對用會員基本資料 */
  originProfile: MemberProfile;
  /** 會員帳號 (身份證字號) */
  memberId: string;
  /** 進行中的頁面 */
  activeStep: MemberMaintainStep;

  /** 發送 OTP 認證碼回傳的結果資訊 */
  otpInfo?: OTPInfo;
  /** 取得 OTP 驗證碼時間 */
  getOTPTime?: number;
  /** 是否需確認手機、電子郵件正確性 */
  notifyVal: boolean;
  /** 表單執行動作 */
  formAction: FormActionsEnum | null;
  /** 表單鎖定 (需點擊編輯按鈕解除鎖定) */
  formLockup: boolean;
};

/** 表單執行動作 */
export enum FormActionsEnum {
  /** 編輯 */
  Edit = 'Edit',
  /** 儲存 */
  Update = 'update'
}
